import api from "../_api";

const actions = {
    updatePrice: ({ commit, dispatch }, payload) => {
        commit("UPDATE_PRICE", payload.price);
    },
    updateInvoiceCart: ({ commit, dispatch }, payload) => {
        commit("UPDATE_INVOICE_CART", payload);
    },
    updateInvoices: ({ commit, dispatch }, payload) => {
        commit("UPDATE_INVOICES", payload);
    },
    invoiceErrors: ({ commit, dispatch }, payload) => {
        commit("INVOICE_ERROR", payload);
    },
    clearInvoiceErrors: ({ commit, dispatch }) => {
        commit("CLEAR_INVOICE_ERROR");
    },
    invoiceRequest: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("INVOICE_LOADING");

            api.invoices()
                .then(resp => {
                    commit("INVOICE_SUCCESS", resp.data.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("INVOICE_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    resetTotals: ({ commit }) => {
        commit("RESET_TOTALS");
    },
    payInvoice: ({ commit, dispatch, state }, payload) => {
        let data = {
            cardData: payload.cardPayload,
            couponCart: payload.couponCart,
            donationCart: payload.donationCart,
            team: payload.team, //@TODO: check if used
            invoice: payload.invoice,
            invoiceCart: state.invoiceCart,
        };

        return new Promise((resolve, reject) => {
            commit("PAYMENT_LOADING");

            api.payInvoice(data)
                .then(resp => {
                    commit("PAYMENT_SUCCESS", resp.data);
                    dispatch("user/userRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("PAYMENT_ERROR", errors);
                    reject(err.response);
                });
        });
    },
    clearPaymentErrors: ({ commit }) => {
        commit("CLEAR_PAYMENT_ERRORS");
    },
};

export default actions;
